import CountriesModule from './countries'
import ProductsModule from './products'

let modules = {
  countries: CountriesModule,
  products: ProductsModule
}

const state = {}

const actions = {
  reset: ({ dispatch, commit }) => {
    dispatch('products/reset')
    dispatch('countries/reset')
  }
}

export default {
  namespaced: true,
  actions,
  state,
  modules
}



// WEBPACK FOOTER //
// ./src/store/modules/communication/index.js